module.exports = __webpack_public_path__ + "static/media/painter.4cdf3ea3.jpg";